import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { PurchaseList } from '../purchase-list/PurchaseList';

/**
 * # ClassifiedPurchase
 *
 * ClassifiedPurchase을 설명하세요.
 */
export const ClassifiedPurchase = types
  .model('ClassifiedPurchase')
  // --------------------------------------------------------------------------
  .props({
    projectTypeCd: types.maybeNull(types.number),
    data: types.maybeNull(types.array(PurchaseList)),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model classifiedPurchase --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IClassifiedPurchase;
      (Object.keys(newProps) as TClassifiedPurchaseKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TClassifiedPurchase = Instance<typeof ClassifiedPurchase>;
type TClassifiedPurchaseSnapshot = SnapshotOut<typeof ClassifiedPurchase>;

export interface IClassifiedPurchase extends TClassifiedPurchase {}
export type TClassifiedPurchaseKeys = keyof TClassifiedPurchaseSnapshot & string;
export interface IClassifiedPurchaseSnapshot extends TClassifiedPurchaseSnapshot {}
export const createClassifiedPurchase = () =>
  types.optional(ClassifiedPurchase, {} as TClassifiedPurchase);
